import { Button, Divider, Grid, Typography } from "@mui/material";
import { useState } from 'react';
import { Form, Formik } from "formik";
import { useRecoilValue } from "recoil";
import { AddPatientToGroupRequestInner, GroupsApi, PatientApi } from "../../../api/medical-operations"
import { configState } from "../../../recoil/atoms";
import AutocompletePatient from "../../MedicalOperations/Appointments/FormFields/AutocompletePatient";
import useStyles from "../../../styles/styles";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useLocation } from 'react-router-dom';

interface LocationState {
  groupID: string;
  groupName: string;
};
type props = {
  handleCloseModal: Function;
};

const AddPatientToGroupModal = ({ handleCloseModal }: props) => {
  const classes = useStyles();
  const config = useRecoilValue(configState);
  const [selectedPatientID, setSelectedPatientID] = useState<string | null>(null);

  const location = useLocation();
  const groupName = location.state ? (location.state as LocationState).groupName : '';

  const addPatientToGroup = (values: any) => {
    if(selectedPatientID !== null){
      const group = new PatientApi(config);
    group
      .addPatientToGroups(selectedPatientID,values)
      .then((res) => {
        toast.success(res?.data?.Message!);
        handleCloseModal();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
    }    
  };

  const handleSubmit = (values: AddPatientToGroupRequestInner, actions: any) => {
    const addedValues: AddPatientToGroupRequestInner = {        
        GroupName: groupName,
    };
    addPatientToGroup([addedValues]);
  };

  return (
    <>
      <Formik
        initialValues={{
          PatientID: '',
        }}
        enableReinitialize={true}
        validationSchema={Yup.object().shape({
          PatientID: Yup.string().trim().required("Required"),
        })}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <Typography variant="h5" gutterBottom sx={{ p: 0 }}>
              {"Add Patient To Group"}
            </Typography>
            <Divider />
            <Grid
              container
              rowSpacing={4}
              spacing={2}
              sx={{
                pt: 4,
                mt: 2,
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <Grid item xs={12} sm={10}>
              <AutocompletePatient
                name="PatientID"
                setSelectedPatientID={setSelectedPatientID}
              />
              </Grid>
              <Grid container />
              <Grid container />
            </Grid>
            <Grid container className={classes.buttons} sx={{ mt: 6 }}>
              <Grid item className={classes.wrapper}>
                <Button onClick={() => handleCloseModal()} variant="contained" color="error" className={classes.button}>
                  Cancel
                </Button>
                <Button type="submit" variant="contained" color="secondary" className={classes.button}>
                  {"Add"}
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddPatientToGroupModal;
